/**
 * Shared avatar URL resolution.
 *
 * Components used to inline their own `getImgUrl` that fell back to
 * `/images/default-image.png`. That path is a runtime upload directory, not
 * build output, so it was excluded from deploys and filled in by hand per
 * tenant — which meant one club served another club's crest as the default
 * avatar, and another served nothing at all (a 404 that the SPA answered with
 * HTML, rendering as a broken image).
 *
 * The placeholder below ships with the build, so every tenant gets the same
 * club-neutral avatar and new tenants are correct with no manual step.
 */
export const AVATAR_PLACEHOLDER = "/assets/avatar-placeholder.svg";

/**
 * @param {string|null|undefined} imageName Stored image name, absolute path or URL.
 * @returns {string} URL safe to use as an <img> src.
 */
export function avatarUrl(imageName) {
  if (typeof imageName !== "string") return AVATAR_PLACEHOLDER;

  const name = imageName.trim();
  if (name === "") return AVATAR_PLACEHOLDER;

  // Legacy rows still store the old shared default by name.
  if (name === "default-image.png" || name === "default-image.jpg") {
    return AVATAR_PLACEHOLDER;
  }

  if (name.startsWith("http://") || name.startsWith("https://")) return name;
  if (name.startsWith("/")) return name;

  return `/images/${name}`;
}
